import { capitalize } from '@caresend/utils';
import { defineComponent } from 'vue';
import __vue_component__ from '../../ui/ImageComponent.vue.js';
import __vue_component__$1 from '../../ui/UserPhoto/UserPhoto.vue.js';

var script = defineComponent({
    name: 'IDCard',
    components: {
        ImageComponent: __vue_component__,
        UserPhoto: __vue_component__$1,
    },
    filters: {
        capitalize,
    },
    props: {
        user: {
            type: Object,
            default: undefined,
        },
        picture: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: 'CLINICIAN',
        },
    },
});

export { script as default };
